import(/* webpackMode: "eager" */ "/opt/certificado-multitenant/releases/20260723213804/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/certificado-multitenant/releases/20260723213804/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CertfiqueTopMenu"] */ "/opt/certificado-multitenant/releases/20260723213804/src/components/certfique/CertfiqueTopMenu.tsx");
